var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8125 15.6875C2.78125 15.6875 1.81875 15.3437 1.0625 14.7937V15.6875C1.0625 16.8562 1.95625 17.75 3.125 17.75C3.125 18.1625 3.4 18.4375 3.8125 18.4375C4.225 18.4375 4.5 18.1625 4.5 17.75H15.5C15.5 18.1625 15.775 18.4375 16.1875 18.4375C16.6 18.4375 16.875 18.1625 16.875 17.75C18.0438 17.75 18.9375 16.8562 18.9375 15.6875V14.7937C18.1812 15.3437 17.2188 15.6875 16.1875 15.6875H3.8125Z",
    fill: "#118F84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5625 3.3125H13.4375V2.625C13.4375 1.45625 12.5437 0.5625 11.375 0.5625H8.625C7.45625 0.5625 6.5625 1.45625 6.5625 2.625V3.3125H2.4375C1.26875 3.3125 0.375 4.20625 0.375 5.375V10.875C0.375 12.8 1.8875 14.3125 3.8125 14.3125H7.3875C7.31875 14.1062 7.25 13.9 7.25 13.625V11.5625C7.25 11.15 7.525 10.875 7.9375 10.875H12.0625C12.475 10.875 12.75 11.15 12.75 11.5625V13.625C12.75 13.9 12.6812 14.1062 12.6125 14.3125H16.1875C18.1125 14.3125 19.625 12.8 19.625 10.875V5.375C19.625 4.20625 18.7313 3.3125 17.5625 3.3125ZM7.9375 2.625C7.9375 2.2125 8.2125 1.9375 8.625 1.9375H11.375C11.7875 1.9375 12.0625 2.2125 12.0625 2.625V3.3125H7.9375V2.625Z",
    fill: "#118F84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployed);
export default __webpack_public_path__ + "static/media/EMPLOYED.aedda245c889f12814b13272c386452d.svg";
export { ForwardRef as ReactComponent };